import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css';

interface Mensagem {
  id: number;
  texto: string;
  tipo: 'amor' | 'desejo' | 'beleza';
}

const IconeCoracao: React.FC<{ className?: string }> = ({ className }) => (
  <span className={className} style={{ fontSize: '1.5rem', color: '#ff6b9d' }}>💖</span>
);

const IconeEstrela: React.FC<{ className?: string }> = ({ className }) => (
  <span className={className} style={{ fontSize: '1.5rem', color: '#ffd700' }}>⭐</span>
);

const IconeSol: React.FC<{ className?: string }> = ({ className }) => (
  <span className={className} style={{ fontSize: '1.5rem', color: '#ffa500' }}>☀️</span>
);

const App: React.FC = () => {
  const [mensagemAtual, setMensagemAtual] = useState(0);
  const [mostrarCoracoes, setMostrarCoracoes] = useState(false);
  const [estaTocando, setEstaTocando] = useState(false);

  const mensagens: Mensagem[] = [
    {
      id: 1,
      texto: "Oi Carol! Desde que te conheci, não paro de pensar em como você é incrível! 😊",
      tipo: 'beleza'
    },
    {
      id: 2,
      texto: "Adorei conversar com você sobre programação... você é muito inteligente! 💻",
      tipo: 'amor'
    },
    {
      id: 3,
      texto: "Espero que vc melhore logo! Quero muito poder conversar mais com vc! 🌟",
      tipo: 'desejo'
    },
    {
      id: 4,
      texto: "vc tem uma energia tão boa... Quero sair com vc pra gente se conhecer! ✨",
      tipo: 'amor'
    },
    {
      id: 5,
      texto: "Que vc fique bem depressa! Mal posso esperar para te conhecer melhor! 🥰",
      tipo: 'desejo'
    },
    {
      id: 6,
      texto: "vc é diferente de qualquer pessoa que já conheci, tem gostos bem legais e fou legal te conhecer! 💕",
      tipo: 'amor'
    },
    {
      id: 7,
      texto: "Fiquei impressionado com vc! Espero que possamos conversar mais em breve! 🚀",
      tipo: 'desejo'
    },
    {
      id: 8,
      texto: "vc é linda e maravilhosa! Só queria que vc soubesse disso! 😍",
      tipo: 'beleza'
    }
  ];

  useEffect(() => {
    const intervalo = setInterval(() => {
      setMensagemAtual((anterior) => (anterior + 1) % mensagens.length);
    }, 4000);

    return () => clearInterval(intervalo);
  }, [mensagens.length]);

  useEffect(() => {
    const intervaloCoracoes = setInterval(() => {
      setMostrarCoracoes(true);
      setTimeout(() => setMostrarCoracoes(false), 2000);
    }, 3000);

    return () => clearInterval(intervaloCoracoes);
  }, []);

  const lidarComCliqueCoracao = () => {
    setEstaTocando(!estaTocando);
    
    const numeroWhatsApp = "5531997338245";
    const mensagem = encodeURIComponent("Oi gostoso!");
    const urlWhatsApp = `https://wa.me/${numeroWhatsApp}?text=${mensagem}`;
    
    window.open(urlWhatsApp, '_blank');
  };

  const renderizarIcone = (tipo: string) => {
    switch (tipo) {
      case 'amor':
        return <IconeCoracao />;
      case 'desejo':
        return <IconeEstrela />;
      case 'beleza':
        return <IconeSol />;
      default:
        return <IconeCoracao />;
    }
  };

  return (
    <div className="app">
      <div className="background">
        <div className="stars"></div>
        <div className="twinkling"></div>
        <div className="clouds"></div>
      </div>

      <AnimatePresence>
        {mostrarCoracoes && (
          <motion.div
            className="floating-hearts"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {[...Array(10)].map((_, i) => (
              <motion.div
                key={i}
                className="heart"
                initial={{ 
                  x: Math.random() * window.innerWidth,
                  y: window.innerHeight + 50,
                  scale: 0
                }}
                animate={{ 
                  y: -100,
                  scale: [0, 1, 0.8, 1],
                  rotate: [0, 360]
                }}
                transition={{ 
                  duration: 3,
                  delay: i * 0.2,
                  ease: "easeOut"
                }}
              >
                💖
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <div className="container">
        <motion.div
          className="header"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className="title">
            <IconeCoracao className="title-heart" />
            Para Carol
            <IconeCoracao className="title-heart" />
          </h1>
          <p className="subtitle">Um sitezinho especial que fiz para você! 💕</p>
        </motion.div>

        <motion.div
          className="message-container"
          key={mensagemAtual}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.8 }}
        >
          <div className={`message ${mensagens[mensagemAtual].tipo}`}>
            <div className="message-icon">
              {renderizarIcone(mensagens[mensagemAtual].tipo)}
            </div>
            <p className="message-text">{mensagens[mensagemAtual].texto}</p>
          </div>
        </motion.div>

        <motion.button
          className="heart-button"
          onClick={lidarComCliqueCoracao}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          animate={{ 
            scale: estaTocando ? [1, 1.2, 1] : 1,
            rotate: estaTocando ? [0, 10, -10, 0] : 0
          }}
          transition={{ 
            duration: 0.5,
            repeat: estaTocando ? Infinity : 0
          }}
        >
          💖
          <span>Clique aqui!</span>
        </motion.button>

        <motion.div
          className="wishes-section"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <h2>Coisas que espero para você:</h2>
          <div className="wishes-grid">
            <motion.div
              className="wish-card"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              💖
              <p>Que melhore logo</p>
            </motion.div>
            <motion.div
              className="wish-card"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              ⭐
              <p>Muitos projetos legais</p>
            </motion.div>
            <motion.div
              className="wish-card"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              ☀️
              <p>Dias sempre felizes</p>
            </motion.div>
            <motion.div
              className="wish-card"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              🌙
              <p>Muita paz e tranquilidade</p>
            </motion.div>
          </div>
        </motion.div>

        <motion.footer
          className="footer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1 }}
        >
          <p>Espero que você goste, Carol! 💖</p>
          <p>Melhore logo para podermos conversar mais! 🌟</p>
        </motion.footer>
      </div>
    </div>
  );
};

export default App;